export function pad(n: number): string {
    return String(n).padStart(2, '0');
}

export function fmtTime(d: Date | string | null | undefined): string {
    if (!d) return '—';
    const x = typeof d === 'string' ? new Date(d) : d;
    return `${pad(x.getHours())}:${pad(x.getMinutes())}`;
}

export function fmtDate(d: Date | string): string {
    return new Date(d).toLocaleDateString('id-ID', { day: '2-digit', month: 'short' });
}

export function fmtDuration(ms: number): string {
    const safe = ms < 0 ? 0 : ms;
    const h = Math.floor(safe / 3_600_000);
    const m = Math.floor((safe % 3_600_000) / 60_000);
    if (h === 0) return `${m}m`;
    return `${h}j ${m}m`;
}

export function fmtMinutes(m: number): string {
    if (m < 60) return `${m}m`;
    const h = Math.floor(m / 60);
    const rest = m % 60;
    return rest === 0 ? `${h}j` : `${h}j ${rest}m`;
}

export type GreetingKind = 'morning' | 'noon' | 'afternoon' | 'evening';

export function greetingKind(d: Date): GreetingKind {
    const h = d.getHours();
    if (h < 11) return 'morning';
    if (h < 15) return 'noon';
    if (h < 18) return 'afternoon';
    return 'evening';
}

export function greetingEmoji(kind: GreetingKind): string {
    return ({ morning: '☀️', noon: '🌤️', afternoon: '🌅', evening: '🌙' })[kind];
}

/**
 * Hitung progress shift saat clock-in masih open.
 * Return null kalau bukan dalam shift hari itu (sebelum start atau setelah end + 8 jam).
 */
export interface ShiftProgressInput {
    now: Date;
    shiftStart: string;  // 'HH:MM'
    shiftEnd: string;
}
export interface ShiftProgress {
    pct: number;            // 0–100
    remainingMs: number;    // negative kalau over
    isOvertime: boolean;
}

export function computeShiftProgress(input: ShiftProgressInput): ShiftProgress {
    const { now, shiftStart, shiftEnd } = input;
    const [sh, sm] = shiftStart.split(':').map(Number);
    const [eh, em] = shiftEnd.split(':').map(Number);
    const start = new Date(now); start.setHours(sh, sm, 0, 0);
    const end = new Date(now); end.setHours(eh, em, 0, 0);
    const total = Math.max(1, end.getTime() - start.getTime());
    const passed = now.getTime() - start.getTime();
    const pct = Math.max(0, Math.min(100, (passed / total) * 100));
    const remainingMs = end.getTime() - now.getTime();
    return { pct, remainingMs, isOvertime: remainingMs < 0 };
}
